module.exports = __webpack_public_path__ + "static/media/how_it_works.aa6ab9a8.svg";